import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon';
import styles from './styles.scss';

const Link = ({
  children,
  className,
  href,
  id,
  onClick,
  prefixIcon,
  suffixIcon,
  target,
  text,
  type,
}) => (
  <a
    id={id}
    target={target}
    href={href}
    onClick={onClick}
    rel={target === '_blank' ? 'noopener noreferrer' : ''}
    className={classNames(className, {
      [styles[`link-${type}`]]: type !== 'primary',
    })}
  >
    {prefixIcon && <Icon icon={prefixIcon} round={false} className={styles.prefixIcon} />}
    {text || children}
    {suffixIcon && <Icon icon={suffixIcon} round={false} className={styles.suffixIcon} />}
  </a>
);

Link.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  href: PropTypes.string,
  id: PropTypes.string,
  onClick: PropTypes.func,
  prefixIcon: PropTypes.string,
  suffixIcon: PropTypes.string,
  target: PropTypes.string,
  text: PropTypes.node,
  type: PropTypes.string,
};

Link.defaultProps = {
  className: '',
  prefixIcon: '',
  suffixIcon: '',
  target: '_self',
  text: '',
  type: 'primary',
};

export default Link;
